<template>
    <div class="social-wrapper">
        <span class="social-share-label">Share</span>
        <a class="social-share-btn" id="facebook-btn" :href="'https://www.facebook.com/sharer/sharer.php?u=' + url + '&display=popup'" onclick="return !window.open(this.href, 'Share to Facebook', 'width=800,height=800')">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 38 38" style="enable-background:new 0 0 38 38;" xml:space="preserve">
                <path d="M26.4,9H11.7C10.2,9,9,10.2,9,11.7v14.6c0,1.5,1.2,2.7,2.7,2.7H19v-7.2h-1.9c-0.2,0-0.5-0.2-0.5-0.5v-2.3
                c0-0.2,0.2-0.5,0.5-0.5H19v-2.3c0-2.6,1.6-4,3.9-4h1.9c0.2,0,0.5,0.2,0.5,0.5v1.9c0,0.2-0.2,0.5-0.5,0.5h-1.2
                c-1.2,0-1.5,0.6-1.5,1.5v1.9h2.7c0.2,0,0.5,0.2,0.5,0.5L25,21.5c0,0.2-0.2,0.4-0.5,0.4H22V29h4.3c1.5,0,2.7-1.2,2.7-2.7V11.7
                C29.1,10.2,27.8,9,26.4,9z"/>
            </svg>
            <!-- <img src="../images/icons/facebook.png" alt=""> -->
        </a>

        <a class="social-share-btn" id="linkedin-btn" :href="'https://www.linkedin.com/shareArticle?mini=true&url='+ url +'&source=LinkedIn'" onclick="return !window.open(this.href, 'Share to LinkedIn', 'width=800,height=800')">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 38 38" style="enable-background:new 0 0 38 38;" xml:space="preserve">
                <path d="M27.4,9H10.5C9.6,9,9,9.6,9,10.5v17.1c0,0.8,0.7,1.5,1.5,1.5h17c0.8,0,1.5-0.6,1.5-1.5V10.5
                C29,9.7,28.3,9,27.4,9z M14.9,26h-3v-9.5h3C14.9,16.5,14.9,26,14.9,26z M13.4,15.2c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7
                c0.9,0,1.7,0.8,1.7,1.7C15.1,14.4,14.4,15.2,13.4,15.2z M26,26h-3v-4.7c0-1.1,0-2.5-1.5-2.5c-1.5,0-1.8,1.2-1.8,2.4V26h-3v-9.5h2.8
                v1.3h0.1c0.4-0.8,1.4-1.5,2.8-1.5c3,0,3.6,2,3.6,4.5L26,26L26,26z"/>
            </svg>
        </a>
    </div>
</template>


<script>
export default {
	props: ["url"],
};
</script>